var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHectareas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#98CBC2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.1,60.4 12.7,60.4 13.6,44.8 18.2,44.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.6,
    y1: 35.7,
    x2: 7.6,
    y2: 38.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11,
    y1: 37.8,
    x2: 11,
    y2: 40.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "35.6,60.4 29.2,60.4 30.1,44.8 34.7,44.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.1,
    y1: 35.7,
    x2: 24.1,
    y2: 38.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.5,
    y1: 37.8,
    x2: 27.5,
    y2: 40.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,38.9L53.5,9.2c-1.1-4.4-8.4-4.4-9.5,0l-7.5,29.7c-0.8,3,1.9,5.9,5.6,5.9h13.4C59.1,44.8,61.8,42,61,38.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "52.1,60.4 45.7,60.4 46.6,44.8 51.2,44.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 40.6,
    y1: 35.7,
    x2: 40.6,
    y2: 38.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 44,
    y1: 37.8,
    x2: 44,
    y2: 40.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,38.9l4-15.9L37,9.2c-1.1-4.4-8.4-4.4-9.5,0L20,38.9c-0.8,3,1.9,5.9,5.6,5.9H39c0.5,0,1.1-0.1,1.5-0.2 C37.7,44,35.9,41.5,36.5,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,38.9l4-15.9L20.5,9.2c-1.1-4.4-8.4-4.4-9.5,0L3.5,38.9c-0.8,3,1.9,5.9,5.6,5.9h13.4c0.5,0,1.1-0.1,1.5-0.2 C21.2,44,19.4,41.5,20,38.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHectareas);
export default __webpack_public_path__ + "static/media/hectareas.2fb97f600d224adce4e2e62eb9d3b73b.svg";
export { ForwardRef as ReactComponent };